<template>
  <div v-if="type !== 'hidden'" class="form-group">
    <label :for="id">{{label}}{{required ? '*' : ''}}: </label>
    <input class="form-control" :type="type"
           :name="name"
           :id="id" :required="required"
           v-bind:value="value"
           v-on:input="$emit('input', $event.target.value)"
           :placeholder="label"
    >
  </div>
  <input v-else :type="type"
         :name="name"
         :id="id" :required="required"
         v-bind:value="value"
         v-on:input="$emit('input', $event.target.value)"
         :placeholder="label"
  >
</template>

<script>
  import { randomString } from '../../utils/string'

  export default {
    name: 'text-input',
    props: {
      name: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'text'
      },
      id: {
        type: String,
        default: () => {
          return randomString()
        }
      },
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      value: ''
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/TextInput.vue